import { REDEEM_GIFT_CARD, CLEAR_REDEEMED_GIFT_CARDS, REMOVE_REDEEMED_GIFT_CARD } from 'actions/actionConstants'
import { DefinedAppAction } from 'actions/types/ActionTypes'
import { RedeemedCard } from 'components/Common/RedeemGiftCard/common'

export interface RedeemedGiftCardsState {
  cards: Array<RedeemedCard>
}

export const initialRedeemedGiftCardsState: RedeemedGiftCardsState = {
  cards: [],
}

export default function redeemedGiftCardsReducer(
  state: RedeemedGiftCardsState = initialRedeemedGiftCardsState,
  action: DefinedAppAction,
): RedeemedGiftCardsState {
  switch (action.type) {
    case REDEEM_GIFT_CARD:
      return {
        ...state,
        cards: [...state.cards, action.card],
      }
    case CLEAR_REDEEMED_GIFT_CARDS:
      return {
        ...state,
        cards: [],
      }
    case REMOVE_REDEEMED_GIFT_CARD:
      return {
        ...state,
        cards: state.cards.filter(card => card.code !== action.code),
      }
    default:
      return state
  }
}
